<template>
  <v-card>
    <v-card-title class="headline colorHeadlineStandard" primary-title>
      {{ $tc('label.company') }}
      <v-spacer />
      <v-icon large @click="$emit('closeDialog', true)">{{ mdiClose }}</v-icon>
    </v-card-title>
    <v-card-text>
      <v-text-field :label="$t('label.companyName')" v-model="company.name" maxlength="128" required hide-details />
      <v-text-field :label="$t('label.vatNumber')" maxlength="32" v-model="company.vatin" hide-details />
      <v-text-field :label="$t('label.address')" maxlength="256" v-model="company.address" />
      <v-textarea :label="$t('label.note')" v-model="company.note" name="input-7-1" maxlength="512" hide-details dense no-resize />
    </v-card-text>
    <v-card-actions>
      <v-btn block color="colorEnter" @click="saveCompany">{{ $t('btn.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';

import { mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'dataEditCompany',
  props: {
    openDialog: Boolean,
  },
  data: () => ({
    listCountries: [],
    company: {
      id: 0,
      name: '',
      vatin: '',
      address: '',
      note: '',
    },
    mdiClose: mdiClose,
  }),
  methods: {
    saveCompany() {
      axios
        .post('/api/v1/company', this.company)
        .then((response) => {
          // Ak je existujuca SPZ (-1) alebo prazdna SPZ (0)
          if (response.data.newCompanyID === -1) {
            this.$store.commit('globalMessage', this.$i18n.t('msg.itemNameExists'));
            return;
          }
          if (response.data.newCompanyID > 0) {
            this.company.id = response.data.newCompanyID; // Ak sa zalozi nove vozidlo updatni ID
            this.$emit('newCompanyID', this.company.id);
            this.$emit('closeDialog', true);
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
